import { useMemo } from 'react'

import Field, { FieldOpts } from './Field'


const useField = (name: Field['name'], opts?: FieldOpts) => {
  const form = useMemo(() => new Field(name, opts), [ name, opts ])

  return form
}


export default useField
